module.exports = __webpack_public_path__ + "img/5ar.6f1ba24a.png";